import { PORTAL_URL } from '@/constants/baseUrls';

const ROOT = '/shop/solar';

export const DIGITAL_COMMERCE_ROUTES = {
  LANDING: ROOT,
  DESIGN: `${ROOT}/design`,
};

export function getPortalOnboardingUrl(proposalId: string) {
  return `${PORTAL_URL}/onboarding?${new URLSearchParams({ proposal: proposalId })}`;
}
